export const userAuth = {
  LOGIN: "LOGIN",
  UPDATE_USER: "UPDATE_USER",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILED: "LOGIN_FAILED",
  LOGOUT: "LOGOUT",
};
